import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 8.248h19.5m-22.5 9h19.5M12 .748l-7.5 22.5m15-22.5-7.5 22.5"
    }, null, -1)
  ]));
}
const mailSignHashtag = { render };
export {
  mailSignHashtag as default,
  render
};
//# sourceMappingURL=mail-sign-hashtag.svg.js.map
